import TaskStore from './TaskStore';
import UserStore from './UserStore';
import PreferencesStore from './PreferencesStore';
import ProjectStore from './ProjectStore';
import FeaturesStore from './FeaturesStore';
import NfcTaskStore from './NfcTaskStore';
var projectStore = new ProjectStore();
var userStore = new UserStore();
var taskStore = new TaskStore(userStore);
var preferencesStore = new PreferencesStore();
var featureStore = new FeaturesStore();
var nfcTaskStore = new NfcTaskStore(userStore);
var loadConfiguration = function (authorized) {
    if (authorized) {
        projectStore.load();
    }
};
userStore.verified.subscribe(loadConfiguration);
userStore.authorization.subscribe(loadConfiguration);
var store = {
    userStore: userStore,
    taskStore: taskStore,
    preferencesStore: preferencesStore,
    projectStore: projectStore,
    featureStore: featureStore,
    nfcTaskStore: nfcTaskStore,
    clear: function () {
        taskStore.clear();
        projectStore.clear();
    }
};
export default store;



//////////////////
// WEBPACK FOOTER
// ./src/store/index.ts
// module id = 87
// module chunks = 0